import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import Firebase from 'Firebase'
import thunk from 'redux-thunk'
import reduxReset from 'redux-reset'
import rootReducer from './reducers'
import history from './history'
import { UserSelectionMiddleware, timeMiddleware } from './middlewares'

const initialState = {
  firebase: Firebase.database().ref()
}
const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history),
  timeMiddleware,
  UserSelectionMiddleware
]

if (__DEV__) {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  reduxReset(),
  ...enhancers
)

const store = createStore(rootReducer, initialState, composedEnhancers)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js